// React router
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// Components
import App from "./App";
import UserService from "./services/UserService";
import { installRequestAuthorization } from "./services/RequestAuthorization";
import { getPublicPath } from "./services/PublicUrl";
// Report web vitals
import reportWebVitals from "./reportWebVitals";
// Styles
import "./style.css";
import "./custom.scss";
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap/dist/js/bootstrap.bundle.min';

const container = document.getElementById("root");
const root = createRoot(container!);

const renderApp = () => root.render(
  <BrowserRouter basename={getPublicPath() || undefined}>
    <App />
  </BrowserRouter>
);

installRequestAuthorization();
UserService.initKeycloak(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
